var a;
((t) => {
  t.htmlDot = "·", t.longDash = "—", t.nbsp = " ";
})(a || (a = {}));
export {
  a as Symbols
};
